import { useRPCContext } from "../../../contexts/RPCContext.js";
import { useEffect } from "react";
//#region src/modules/Locations/shared/UserClientViewingLocation.tsx
function UserClientViewingLocation({ locationId }) {
	const { rpcService } = useRPCContext();
	useEffect(() => {
		const t = setTimeout(() => rpcService.UserClient.ViewLocation.v1.call({ locationId }), 3e3);
		return () => {
			clearTimeout(t);
		};
	}, [locationId]);
	return null;
}
//#endregion
export { UserClientViewingLocation };

//# sourceMappingURL=UserClientViewingLocation.js.map